import {Environment, Network, FetchFunction, Store, RecordSource} from "relay-runtime";

const baseURL = window.location.origin;


export const GRAPHQL_ENDPOINT = `${baseURL}/graphql`;


const fetchGraphQL: FetchFunction = async (request, variables) => {
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    const resp = await fetch(GRAPHQL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", 'X-CSRF-Token': csrfToken },
        body: JSON.stringify({ query: request.text, variables }),
    });
    if (!resp.ok) {
        throw new Error("Response failed.");
    }
    return await resp.json();
};

function createEnvironment() {
    return new Environment({
        network: Network.create(fetchGraphQL),
        store: new Store(new RecordSource()),
    });
}

export const relayEnvironment: Environment = createEnvironment();